import React from "react";
import { MapContainer, TileLayer, Popup, Marker } from 'react-leaflet'
import 'leaflet/dist/leaflet.css' 
import './location.css'
import markerIconPng from "leaflet/dist/images/marker-icon.png"
import { Icon } from 'leaflet'
import Container from 'react-bootstrap/Container';


export function Location () {
    return (
        <>
        <h5 className="d-flex justify-content-center text-light">Location</h5>
        <Container fluid='xl' className=''>
            <MapContainer className="map_wrapper" center={[-7.4841564 , 112.702186]} zoom={18}>
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    <Marker position={[-7.484156, 112.702186]}
                    icon={new Icon({iconUrl: markerIconPng, iconSize: [25, 41]})}
                        >
                    <Popup>
                        Vida Trans.
                    </Popup>
                    </Marker>
            </MapContainer>
            <div>
            <button className="btn btn-primary m-2">
                <a href="https://goo.gl/maps/1oSgwCvN53HKZbFi6" className="text-decoration-none text-light" target="blank">Open Location</a>
            </button>
            </div>
        </Container>
        </>
    )
}